import { Injectable } from "@angular/core";
import { API_ENDPOINTS } from "../constants/api-endpoints";

@Injectable({
  providedIn: "root",
})
export class ApiVariablesService {
  /**
   * Restituisce l'endpoint corrispondente alla chiave passata
   * @param key - La chiave dell'endpoint (es. 'login', 'logout', ecc.)
   * @returns string - L'endpoint corrispondente o stringa vuota se non trovato
   */
  getEndpoint(key: string): string {
    return API_ENDPOINTS[key] || "";
  }
}
